import React from "react";

import "./formLabel.styles.scss";

interface FormLabelProps {
  children: any;
  labelIdentifier: string;
  isRequired?: boolean;
  isInvalid?: boolean;
}

const FormLabel = ({
  children,
  labelIdentifier,
  isRequired,
  isInvalid,
}: FormLabelProps) => (
  <label
    id={`${labelIdentifier}-label`}
    className={`formLabel ${isInvalid ? "formLabel_error" : ""}`}
    htmlFor={labelIdentifier}
  >
    {children}
    {isRequired && (
      <span
        className="formLabel-isRequired"
        role="presentation"
        aria-hidden="true"
      >
        *
      </span>
    )}
  </label>
);

export default FormLabel;
